import { css } from 'lit';

export const IxFilterSelectStyles = css`
  :host {
    display: block;
  }
  :host([disabled]) {
    pointer-events: none;
  }
  ix-field {
    display: block;
  }
  ix-field label {
    display: none;
  }
  .flex-fill {
    flex: 1;
  }
  .menu {
    position: relative;
  }
  .menu label,
  .menu input {
    cursor: pointer;
  }
  input {
    border: none;
    background: transparent;
    outline: none;
    min-width: 3rem;
  }
  ix-chip-set {
    min-height: var(--_content-line-height);
  }
  ix-menu {
    --md-menu-container-color: var(--md-sys-color-surface-variant, #fff);
    max-height: var(--ix-filter-select-max-height, 500px);
  }
  ix-menu-item {
    position: relative;
  }
  ix-menu-item label {
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  ix-menu-item label input[type='checkbox'] {
    margin: 0 1rem 2px;
  }
  ix-menu-item.selected {
    background: var(
      --md-menu-item-selected-container-color,
      --md-sys-color-tertiary-container
    );
  }
  ix-icon-button {
    --md-icon-button-icon-color: var(--md-sys-text-color-secondary);
    --md-icon-button-hover-icon-color: var(--md-sys-text-color-secondary);
    --md-icon-button-hover-state-layer-color: var(
      --md-sys-text-color-secondary
    );
    --md-icon-button-pressed-icon-color: var(--md-sys-text-color-secondary);
    --md-icon-button-pressed-state-layer-color: var(
      --md-sys-text-color-secondary
    );
  }
  .open-icon {
    margin-right: 0.5rem;
  }
  .filter-select {
    position: relative;
  }

  .filter-select-footer-section {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 1rem;
  }
`;
